import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.startX = 0
    this.startY = 0
    this.currentX = 0
    this.isSwiping = false

    this.showSwipeHintOnce()

    this.element.addEventListener("touchstart", this.onTouchStart, { passive: true })
    this.element.addEventListener("touchmove", this.onTouchMove, { passive: true })
    this.element.addEventListener("touchend", this.onTouchEnd)
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this.onTouchStart)
    this.element.removeEventListener("touchmove", this.onTouchMove)
    this.element.removeEventListener("touchend", this.onTouchEnd)
  }

  // --------------------------------
  // Swipe hint (first load only)
  // --------------------------------
  showSwipeHintOnce() {
    if (window.innerWidth > 768) return

    if (!localStorage.getItem("compactSwipeHintShown")) {
      this.element.classList.add("show-swipe-hint")

      setTimeout(() => {
        this.element.classList.remove("show-swipe-hint")
      }, 1400)

      localStorage.setItem("compactSwipeHintShown", "true")
    }
  }

  // --------------------------------
  // Touch start
  // --------------------------------
  onTouchStart = (e) => {
    if (e.touches.length !== 1) return

    this.startX = e.touches[0].clientX
    this.startY = e.touches[0].clientY
    this.currentX = this.startX
    this.isSwiping = true
  }

  // --------------------------------
  // Touch move (elastic resistance)
  // --------------------------------
  onTouchMove = (e) => {
    if (!this.isSwiping) return

    this.currentX = e.touches[0].clientX
    const dx = this.currentX - this.startX
    const dy = e.touches[0].clientY - this.startY

    // Ignore vertical scroll
    if (Math.abs(dy) > Math.abs(dx)) {
      this.isSwiping = false
      this.resetTransform()
      return
    }

    // Elastic resistance
    const resisted = dx * 0.35
    this.element.style.transform = `translateX(${resisted}px)`
  }

  // --------------------------------
  // Touch end (commit swipe)
  // --------------------------------
  onTouchEnd = () => {
    if (!this.isSwiping) return

    this.resetTransform()

    const dx = this.currentX - this.startX
    const threshold = 70

    if (dx < -threshold) {
      this.openRightPanel()
    }

    if (dx > threshold) {
      this.openLeftPanel()
    }

    this.isSwiping = false
  }

  // --------------------------------
  // Panel actions
  // --------------------------------
  openRightPanel() {
    this.element.classList.add("is-right-open")
    this.haptic()
  }

  openLeftPanel() {
    this.element.classList.remove("is-right-open")
    this.haptic()
  }

  resetTransform() {
    this.element.style.transform = ""
  }

  // --------------------------------
  // Haptic feedback (safe)
  // --------------------------------
  haptic() {
    if (window.navigator?.vibrate) {
      navigator.vibrate(12)
    }
  }
}
